import React from 'react';

import { EmptyDataIcon } from 'components/icons-new/empty-data';
import { Text } from 'common/common-components.styled';

import { StyledWidgetTileEmptyPlaceholderContainer } from './empty.styled';

type WidgetTileEmptyPlaceholderProps = {
  label?: string;
  icon?: React.ReactNode;
};

export const WidgetTileEmptyPlaceholder = ({
  icon = <EmptyDataIcon hovered />,
  label = 'Nichts gefunden'
}: WidgetTileEmptyPlaceholderProps) => {
  return (
    <StyledWidgetTileEmptyPlaceholderContainer>
      {icon}
      <Text color='blue' size='18' bold top='20'>
        {label}
      </Text>
    </StyledWidgetTileEmptyPlaceholderContainer>
  );
};
